import * as React from 'react';
import { useContext, useState } from 'react';
import { AuthContext } from '../_auth/AuthContext';
import { Button, Grid } from '@material-ui/core';
import { setSessionCookie } from '../_service/cookie';
import { ObliterateMe } from '../_service/auth';
import { Braze_Page } from './Braze';

interface Props {

};

const TestingHome: React.FC<Props> = (prop: Props) => {
  const { user, setUser } = useContext(AuthContext);

  const [confirmObliterateMe, setConfirmObliterateMe] = useState<string | null>(null);

  const _obliterateMe = () => {

    if (confirmObliterateMe == null) {
      setConfirmObliterateMe("This Time For Realzies")
    } else {
      let id = user.id!;
      user.authorized = false;
      ObliterateMe(id).then(p => {
        setUser(prv => { return { ...user }; });
        setSessionCookie(null);
        window.location.href = "/";
      });
    }
  }

  const _logout = () => {
    user.authorized = false;

    setUser(prv => { return { ...user }; });
    setSessionCookie(null);
    window.location.href = "/";
  }

  const jUser = JSON.stringify(user, null, 2);

  return (
    <React.Fragment>
      <Grid>
        <Grid item><Button variant="contained" color="secondary" onClick={_obliterateMe}>{(!confirmObliterateMe) ? "Obliterate Me" : confirmObliterateMe}</Button></Grid>
      </Grid>
      <Grid style={{ marginTop: 5 }}>
        <Grid item><Button variant="contained" color="primary" onClick={_logout}>Log Out</Button></Grid>
      </Grid>
      <Grid style={{ marginTop: 5 }}>
        <Grid item><Braze_Page></Braze_Page></Grid>
      </Grid>
    </React.Fragment>
  )
}

export default TestingHome;